import { render, staticRenderFns } from "./editStoreSubmit.vue?vue&type=template&id=20c88e2f&scoped=true&"
import script from "./editStoreSubmit.vue?vue&type=script&lang=js&"
export * from "./editStoreSubmit.vue?vue&type=script&lang=js&"
import style0 from "./editStoreSubmit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editStoreSubmit.vue?vue&type=style&index=1&id=20c88e2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c88e2f",
  null
  
)

export default component.exports